export const courseList = [
  {
    title: "DCA+",
    short: "Advanced computer applications course for professionals.",
    full: `🔹 DCA PLUS (Diploma in Computer Application)
W.E.F. 01-04-24
Duration: 12 Months | Eligibility: Min 10th

Modules:
Semester I:
- Fundamental of Computer
- Operating System (Windows)
- Office Package (MS Word, Excel, PowerPoint)
- Libre Office
- Concept of Internet
  - Web Page Accessing
  - E-Mail Account Creation
  - E-Mail Sending/Receiving
  - File Attachment
  - Downloading
  - Online Form Filling
  - Railway Reservation
- Tally
  - Concept of Accounting
  - Account Management
  - Inventory Management
  - Account with Inventory
  - Tax Accounting (with GST)
  - Payroll Management

Semester II:
- MS Access (Database)
- Web Designing
- Page Maker
- Coral Draw
- Photo Shop
- Project Work in Access (Database)`,
  },
  {
    title: "CCC",
    short: "A basic computer literacy course for everyone.",
    full: `🔹 CCC (Course on Computer Concepts) - NIELIT
Duration: 3–4 Months

Modules:
- Computer Fundamental
- Operating System
- MS Word
- MS Excel
- MS PowerPoint
- Internet and Networking`,
  },
  {
    title: "O-Level",
    short: "Foundation-level IT course to start your IT career.",
    full: `🔹 ‘O’ Level – NIELIT
Duration: 1 Year

Modules:
- M1 – IT Tools and Business System
- M2 – Internet Technology and Web Design
- M3 – Python
- M4 – Internet Technology
- Practical`,
  },
  {
    title: "DFA",
    short: "Focuses on accounting software and financial systems.",
    full: `DFA (Diploma in Financial Accounting) is a practical course that teaches
accounting principles using tools like Tally ERP, GST accounting, payroll, and financial statements.
Useful for jobs in finance and accounting.`,
  },
  {
    title: "CCO",
    short: "Office tools and basic computer knowledge.",
    full: `🔹 CCO (Certificate Course in Office Automation)
W.E.F. 01-04-24
Duration: 3–4 Months

Modules:
- Fundamental of Computer T
- Operating System (Windows)
- M.S. Word
- M.S. Excel
- M.S. PowerPoint
- Office Package
- Concept of Internet
  - Web Page Accessing
  - E-Mail Sending/Receiving
  - E-Mail Account Creation
  - File Attachment
  - Downloading`,
  },
  {
    title: "ADCA",
    short: "In-depth computer applications course with programming.",
    full: `🔹 ADCA (Advance Diploma in Computer Application)
W.E.F. 01-04-2024
Duration: 10–12 Months | Eligibility: Min 10th

Modules:
Semester I:
- Fundamental of Computer
- Operating System (Windows)
- MS-Office Package (Word, Excel, PowerPoint)
- Libre Office
- Concept of Internet
  - Web Page Accessing
  - E-Mail Sending/Receiving
  - Downloading
  - Railway Reservation
  - E-Mail Account Creation
  - File Attachment
  - Form Filling
  - Online Shopping

Semester II:
- Tally
  - Concept of Accounting
  - Inventory Management
  - Tax Accounting (with GST)
  - Account Management
  - Account with Inventory
  - Payroll Management
- Page Maker
- Coral Draw
- Photo Shop
- Project`,
  },
  {
    title: "Typing",
    short: "Master your typing speed and accuracy in Hindi and English.",
    full: `🔹 Typing Course (English & Hindi)
Duration: 3–6 Months

Modules:
- English Typing (Touch Typing Technique)
- Hindi Typing (Mangal & KrutiDev Fonts)
- Keyboard Mastery & Finger Positioning
- Speed Building Exercises (WPM Improvement)
- Accuracy Improvement Techniques
- Numeric Keypad Training
- Special Character & Symbol Mastery
- Real-time Typing Tests & Performance Tracking
- Basic Document Formatting & Typing for Exams`,
  },
  {
    title: "CFA PLUS",
    short: "Comprehensive course in computerized financial accounting and Tally.",
    full: `🔹 CFA PLUS (Computerized Financial Accounting) - Tally
Duration: 3–4 Months

Modules:
- Fundamental Of Accounting
- Concept Of A/c & Handling
- Inventory Management & Account With Inventory Complete(GST)
- Tax Accounting
- Balance sheet & Profit / Loss Sheet Preparing
- Payroll Management`,
  },
  {
    title: "DTP",
    short: "Professional desktop publishing course covering design and layout.",
    full: `🔹 DTP (Desktop Publication)
Duration: 3–4 Months

Modules:
- Adobe Page Maker
- Corel DRAW
- Photoshop`,
  },
];
